export default __webpack_public_path__ + "static/media/card-profile4-square.5020d349.jpg";